import Logger from '../../functions/logging';

import { 
	SET_TARGET_PROCESS, 
	SET_FETCHED_DISTRIBUTION_LIST, 
	SET_FETCHED_GROUP, 
	SET_FETCHED_GROUP_PANEL_SEGMENT,
	SET_FETCHED_PANEL, 
	SET_FETCHED_EPISODE,
	SET_PANEL_PARTNER
} from '../actions/constants';

const INITIAL_STATE = {};

export default function (state = INITIAL_STATE, action) {
	Logger.log("targetProcess.js REDUCER()", action.type);

	switch (action.type) {
		case SET_TARGET_PROCESS:
			return { ...state, targetParams: action.params };

		case SET_FETCHED_DISTRIBUTION_LIST:
			return { ...state, fetchedDistributionList: action.distributionList };

		case SET_FETCHED_GROUP:
			return { ...state, fetchedGroup: action.group };

		case SET_FETCHED_PANEL:
			return { ...state, fetchedPanel: action.panel };

		case SET_FETCHED_GROUP_PANEL_SEGMENT:
			return { ...state, fetchedGroupPanelSegment: action.groupPanelSegment };

		case SET_FETCHED_EPISODE:
			return { ...state, fetchedEpisode: action.episode };
		
		case SET_PANEL_PARTNER:
			return { ...state, panelPartner: action.partner };
		
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/targetProcess.js